import routes from 'global/Constants/routes';

import { lazy } from 'react';

//sender
const SenderAddressPage = lazy(() => import('../../pages/dashboard/PeopleAddress/senderAddress/SenderAddress'));
const SenderAddressPageCreate = lazy(() => import('../../pages/dashboard/PeopleAddress/senderAddress/SenderAddressCreate'));
const SenderAddressPageUpdate = lazy(() => import('../../pages/dashboard/PeopleAddress/senderAddress/SenderAddressUpdate'));

//reciver
const RecieverAddressPage = lazy(() => import('../../pages/dashboard/PeopleAddress/receiverAddress/ReceiverAddress'));
const RecieverAddressPageCreate = lazy(() => import('../../pages/dashboard/PeopleAddress/receiverAddress/ReceiverAddressCreate'));
const RecieverAddressPageUpdate = lazy(() => import('../../pages/dashboard/PeopleAddress/receiverAddress/ReceiverAddressUpdate'));
const RecieverAddressTest = lazy(() => import('../../pages/dashboard/PeopleAddress/receiverAddress/RecieverAddressTest'));
export const addressRoutes = (hasAccessLevel: (_level: number) => boolean) => [
  //RECIVER
  {
    path: routes.recieverAddressCreate.path,
    component: RecieverAddressPageCreate,
    isPrivate: routes.recieverAddressCreate.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  {
    path: routes.recieverAddressTest.path,
    component: RecieverAddressTest,
    isPrivate: routes.recieverAddressTest.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  {
    path: routes.recieverAddressUpdate.path,
    component: RecieverAddressPageUpdate,
    isPrivate: routes.recieverAddressUpdate.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  {
    path: routes.recieverAddress.path,
    component: RecieverAddressPage,
    isPrivate: routes.recieverAddress.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  //SENDER
  {
    path: routes.senderAddressCreate.path,
    component: SenderAddressPageCreate,
    isPrivate: routes.senderAddressCreate.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  {
    path: routes.senderAddressUpdate.path,
    component: SenderAddressPageUpdate,
    isPrivate: routes.senderAddressUpdate.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  {
    path: routes.senderAddress.path,
    component: SenderAddressPage,
    isPrivate: routes.senderAddress.isPrivate,
    accessRole: hasAccessLevel(10),
  },
];
